import React from 'react';

import S from 'app/features/newLanding/components/newProductComparison/Product/Benefit.styled';

const BenefitCheckMarkIcon = props => (
  <S.Benefit.CheckMark
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    data-t="checkmark-svg"
    aria-labelledby="checkmark-svg"
    role="img"
    {...props}
  >
    <title id="checkmark-svg">Checked</title>
    <path d="M8.75 15a1.25 1.25 0 01-.88-.37l-3.75-3.75a1.25 1.25 0 011.76-1.76l2.79 2.78 5.37-6.45a1.25 1.25 0 111.92 1.6l-6.25 7.5c-.23.27-.55.43-.9.45h-.06" />
  </S.Benefit.CheckMark>
);

export default BenefitCheckMarkIcon;
